jQuery(document).ready(function ($) {

    /**
     * Search
     */
    $('.postarchive-search > .searchsubmit').on('click', function () {

        $parent = $(this).closest('.postarchive');
        $keyword = $parent.find('.postarchive-search > .searchfield').val();
        $data_attributes = JSON.parse($parent.attr('data-atts'));
        $data_attributes['s'] = $keyword;
        $data_attributes['paged'] = 1;
        $parent.attr('data-atts', JSON.stringify($data_attributes));

        fetch_postarchive_data($data_attributes, $parent.find('.posts'), $(this));

    });

    $('.postarchive-search > .searchsubmit, .postarchive-search > .searchfield').on('keypress', function (e) {
        if (e.which == 13) {
            $(this).closest('.postarchive').find('.postarchive-search > .searchsubmit').trigger('click');
        }
    })


    /**
     * Fetch postarchive data
     */
    function fetch_postarchive_data($data_attributes, $output, $this) {
        $this.addClass('loading');
        $output.addClass('loading');
        $.ajax({
            type: 'POST',
            url: CustomBlocks.ajaxurl,
            data: {
                action: 'data_fetch',
                ajaxnonce: CustomBlocks.ajaxnonce,
                attributes: $data_attributes,
            },
            success: function (data, textStatus, XMLHttpRequest) {
                $output.html(data);
                $this.removeClass('loading');
                $output.removeClass('loading');
                update_filter($this);
            },
            error: function (MLHttpRequest, textStatus, errorThrown) {
                console.log(errorThrown);
            }
        });

    }

    /**
     * Load more
     */
    $('.postarchive-loadmore').on('click', function () {

        $parent = $(this).closest('.postarchive');
        $this = $(this);
        $data_attributes = JSON.parse($parent.attr('data-atts'));
        $data_attributes['paged'] = parseInt($data_attributes['paged']) + 1;
        $this.addClass('loading');

        $.ajax({
            type: 'POST',
            url: CustomBlocks.ajaxurl,
            data: {
                action: 'load_more',
                ajaxnonce: CustomBlocks.ajaxnonce,
                attributes: $data_attributes,
            },
            success: function (response) {
                if (response?.data) {
                    $parent.find('.posts').append(response.data);
                    if (!response.has_more_posts) {
                        $this.hide();  // Button ausblenden, wenn keine weiteren Posts
                    }
                } else {
                    $this.hide();  // Button ausblenden, wenn keine Daten
                }
                $this.removeClass('loading');
            },
            error: function (MLHttpRequest, textStatus, errorThrown) {
                console.log(errorThrown);
            }
        });    

        // $(this).attr('data-page', $page);
        $parent.attr('data-atts', JSON.stringify($data_attributes));

    });


    /**
     * Filter
     */
    $('.postarchive-categoryfilter').on('change', 'select', function () {
        filter_posts($(this));
    })
    $('.postarchive-categoryfilter').on('click', 'input', function () {
        filter_posts($(this));
    });
    $('.postarchive-yearfilter').on('click', 'input', function () {
        filter_posts_years($(this));
    });

    function filter_posts(elem) {
        var $container = elem.closest('.postarchive-categoryfilter');
        $parent = elem.closest('.postarchive');
        $filter = [];
        $parent.find('input:checked').each(function () {
            $filter.push($(this).val());
        });
        $parent.find('select option:checked').each(function () {
            if (typeof $(this).val() !== null && $(this).val() != "") {
                $filter.push($(this).val());
            }
        });

        // update data attributes
        $data_attributes = JSON.parse($parent.attr('data-atts'));
        $data_attributes['categories'] = $filter;
        $data_attributes['paged'] = 1;
        $data_attributes['s'] = $parent.find('.postarchive-search > .searchfield').val();
        $parent.attr('data-atts', JSON.stringify($data_attributes));

        // fetch posts
        fetch_postarchive_data($data_attributes, $parent.find('.posts'), elem.next('label'));
    }

    function filter_posts_years(elem) {
        var $container = elem.parent('.postarchive-yearfilter');
        $parent = elem.closest('.postarchive');
        $filter = [];
        $parent.find('input:checked').each(function () {
            $filter.push($(this).val());
        });
        $parent.find('select option:checked').each(function () {
            if (typeof $(this).val() !== null && $(this).val() != "") {
                $filter.push($(this).val());
            }
        });

        // update data attributes
        $data_attributes = JSON.parse($parent.attr('data-atts'));
        $data_attributes['years'] = $filter;
        $data_attributes['paged'] = 1;
        $data_attributes['s'] = $parent.find('.postarchive-search > .searchfield').val();
        $parent.attr('data-atts', JSON.stringify($data_attributes));

        // fetch posts
        fetch_postarchive_data($data_attributes, $parent.find('.posts'), elem.next('label'));
    }

    /**
     * Reset Filter
     */
    $('.postarchive_filter-reset').on('click', function (e) {
        // uncheck all
        $(this).closest('.postarchive').find('.postarchive-categoryfilter').find('input').not('.is-always-checked').prop('checked', false);
        $(this).closest('.postarchive').find('.postarchive-yearfilter').find('input').prop('checked', false);

        // clear search
        $(this).closest('.postarchive').find('.postarchive-search > .searchfield').val('');

        // update data attributes
        $data_attributes = JSON.parse($parent.attr('data-atts'));
        $data_attributes['categories'] = $data_attributes['categories_preset'];
        $data_attributes['years'] = [];
        $data_attributes['s'] = '';
        $parent.attr('data-atts', JSON.stringify($data_attributes));

        // fetch posts
        fetch_postarchive_data($data_attributes, $parent.find('.posts'), $(this));
    })


    /**
     * Update AZ Filter
     */
    function update_filter($this) {
        $parent = $this.closest('.postarchive');

        $parent.find('.postarchive-az-filter').find('.letter').each(function () {
            var letter = $(this).text();

            if ($parent.find('.posts').find('.letter#' + letter).length) {
                $(this).removeClass('disabled');
            } else {
                $(this).addClass('disabled');
            }
        });


    }

});


// WEBPACK FOOTER //
// ./src/blocks/postarchive/js/script.js